<p-toast></p-toast>
<section id="intro" class="clearfix">
  <div class="container">
    <div class="card">
      <div class="card-header">
        <h1 id="tableLabel">Pagamentos</h1>
      </div>
      <div class="card-body">
        <p-toolbar styleClass="mb-4 gap-2">
          <ng-template #start>
            <button
              pButton
              pRipple
              label="Novo"
              icon="pi pi-plus"
              class="p-button-success mr-2"
              (click)="openNew()"
            ></button>
            <button
              pButton
              pRipple
              label="Checa Pagamentos"
              icon="pi pi-check"
              class="p-button-success mr-2"
              (click)="checaPagamentos()"
            ></button>
          </ng-template>
        </p-toolbar>

        <p-table
          *ngIf="showList"
          [value]="pagamentos"
          dataKey="id"
          [tableStyle]="{ 'min-width': '60rem' }"
          editMode="row"
          sortMode="multiple"
        >
          <ng-template #header>
            <tr>
              <th pSortableColumn="id">
                Id <p-sortIcon field="id"></p-sortIcon>
              </th>
              <th>Status</th>
              <th pSortableColumn="vencimento">
                Vencimento <p-sortIcon field="vencimento"></p-sortIcon>
              </th>
              <th pSortableColumn="tecnico_id">
                Técnico <p-sortIcon field="tecnico_id"></p-sortIcon>
              </th>
              <th pSortableColumn="cliente_id">
                Cliente <p-sortIcon field="cliente_id"></p-sortIcon>
              </th>
              <th pSortableColumn="periodo_id">
                Período <p-sortIcon field="periodo_id"></p-sortIcon>
              </th>
              <th pSortableColumn="filial_id">
                Filial <p-sortIcon field="filial_id"></p-sortIcon>
              </th>
              <th pSortableColumn="chave_pix">
                ChavePix <p-sortIcon field="chave_pix"></p-sortIcon>
              </th>
              <th pSortableColumn="valor">
                Valor <p-sortIcon field="valor"></p-sortIcon>
              </th>

              <th style="width: 5rem"></th>
            </tr>
          </ng-template>
          <ng-template
            #body
            let-pagamento
            let-editing="editing"
            let-ri="rowIndex"
          >
            <tr [pEditableRow]="pagamento">
              <td>
                {{ pagamento.id }}
              </td>
              <td>
                <p-tag
                  [value]="pagamento.status_banco"
                  [severity]="getSeverity(pagamento.status_banco)"
                ></p-tag>
              </td>
              <td>
                <p-cellEditor>
                  <ng-template pTemplate="input">
                    <p-calendar
                      [(ngModel)]="pagamento.vencimento"
                      dateFormat="dd/mm/yy"
                      monthNavigator="true"
                      yearNavigator="true"
                      placeholder="Selecione uma data"
                      appendTo="body"
                      [minDate]="minDate"
                    ></p-calendar>
                  </ng-template>
                  <ng-template pTemplate="output">
                    {{ pagamento.vencimento | date : 'dd/MM/yyyy' }}
                  </ng-template>
                </p-cellEditor>
              </td>

              <td>
                <p-cellEditor>
                  <ng-template pTemplate="input">
                    <p-dropdown
                      [options]="tecnicos"
                      [(ngModel)]="pagamento.tecnico_id"
                      [showClear]="true"
                      [filter]="true"
                      filterBy="nome"
                      placeholder="Selecione um técnico"
                      optionLabel="nome"
                      optionValue="id"
                      [style]="{ width: '100%' }"
                      appendTo="body"
                      (onChange)="
                        onChangeTecnico(pagamento.tecnico_id, pagamento)
                      "
                    ></p-dropdown>
                  </ng-template>
                  <ng-template pTemplate="output">
                    {{ nomeTecnico(pagamento.tecnico_id) }}
                  </ng-template>
                </p-cellEditor>
              </td>
              <td>
                <p-cellEditor>
                  <ng-template pTemplate="input">
                    <p-dropdown
                      [options]="clientes"
                      [(ngModel)]="pagamento.cliente_id"
                      [showClear]="true"
                      [filter]="true"
                      filterBy="nome"
                      placeholder="Selecione um cliente"
                      optionLabel="nome"
                      optionValue="id"
                      [style]="{ width: '100%' }"
                      appendTo="body"
                    ></p-dropdown>
                  </ng-template>
                  <ng-template pTemplate="output">
                    {{ nomeCliente(pagamento.periodo_id) }}
                  </ng-template>
                </p-cellEditor>
              </td>
              <td>
                <p-cellEditor>
                  <ng-template pTemplate="input">
                    <p-dropdown
                      [options]="periodosCliente(pagamento.cliente_id)"
                      [(ngModel)]="pagamento.periodo_id"
                      [showClear]="true"
                      [filter]="true"
                      filterBy="descricao"
                      placeholder="Selecione um período"
                      optionLabel="descricao"
                      optionValue="id"
                      [style]="{ width: '100%' }"
                      appendTo="body"
                    ></p-dropdown>
                  </ng-template>
                  <ng-template pTemplate="output">
                    {{ nomePeriodo(pagamento.periodo_id) }}
                  </ng-template>
                </p-cellEditor>
              </td>
              <td>
                <p-cellEditor>
                  <ng-template pTemplate="input">
                    <p-dropdown
                      [options]="filiais"
                      [(ngModel)]="pagamento.filial_id"
                      [showClear]="true"
                      [filter]="true"
                      filterBy="nome"
                      placeholder="Selecione uma filial"
                      optionLabel="nome"
                      optionValue="id"
                      [style]="{ width: '100%' }"
                      appendTo="body"
                    ></p-dropdown>
                  </ng-template>
                  <ng-template pTemplate="output">
                    {{ nomeFilial(pagamento.filial_id) }}
                  </ng-template>
                </p-cellEditor>
              </td>

              <td>
                <p-cellEditor>
                  <ng-template pTemplate="input">
                    <input
                      pInputText
                      type="text"
                      [(ngModel)]="pagamento.chave_pix"
                    />
                  </ng-template>
                  <ng-template pTemplate="output">
                    {{ pagamento.chave_pix }}
                  </ng-template>
                </p-cellEditor>
              </td>
              <td>
                <p-cellEditor>
                  <ng-template pTemplate="input">
                    <input
                      pInputText
                      type="text"
                      [(ngModel)]="pagamento.valor"
                    />
                  </ng-template>
                  <ng-template pTemplate="output">
                    {{ pagamento.valor | currency : 'BRL' }}
                  </ng-template>
                </p-cellEditor>
              </td>

              <td>
                <div
                  class="flex align-items-center justify-content-center gap-2"
                >
                  <button
                    *ngIf="!editing && pagamento.saldo > 0"
                    pButton
                    pRipple
                    type="button"
                    pInitEditableRow
                    icon="pi pi-pencil"
                    (click)="onRowEditInit(pagamento)"
                    class="p-button-rounded p-button-text"
                  ></button>
                  <button
                    *ngIf="!editing && pagamento.saldo > 0"
                    pButton
                    pRipple
                    icon="pi pi-trash"
                    class="p-button-rounded p-button-text p-button-danger"
                    (click)="onDelete(pagamento)"
                  ></button>
                  <button
                    *ngIf="editing"
                    pButton
                    pRipple
                    type="button"
                    pSaveEditableRow
                    icon="pi pi-check"
                    (click)="onRowEditSave(pagamento)"
                    class="p-button-rounded p-button-text p-button-success mr-2"
                  ></button>
                  <button
                    *ngIf="editing"
                    pButton
                    pRipple
                    type="button"
                    pCancelEditableRow
                    icon="pi pi-times"
                    (click)="onRowEditCancel(pagamento, ri)"
                    class="p-button-rounded p-button-text p-button-danger"
                  ></button>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</section>

<p-confirmDialog [style]="{ width: '450px' }"></p-confirmDialog>
